export const SPACING_UNIT = 8;
export const SPACING_REGULAR = 16;
export const SPACING_LARGE = 32;
export const SPACING_HUGE = 40;
